module.exports = __webpack_public_path__ + "static/clients-clickcard-3a2c7e60b0f38df2321392209ee7abcd.svg";